import {PropsWithChildren, useMemo} from 'react';

import {FilterDialogSectionId} from 'filters/features/FilterDialog/types';
import {FilterTopbarItemId} from 'filters/features/FilterTopbar/types';

import {useClientTagsTopbarItem} from 'features/GlobalFilterProvider/filters/clientTags';
import {departmentsTopbarItems} from 'features/GlobalFilterProvider/filters/departments';
import {usePeriodTopbarItems} from 'features/GlobalFilterProvider/filters/period';
import {usePolicyTagsTopbarItems} from 'features/GlobalFilterProvider/filters/policyTags';
import {useTeamsTopbarItems} from 'features/GlobalFilterProvider/filters/teams';
import {useGlobalFilterTopbarEndAdornment} from 'features/GlobalFilterProvider/hooks/useGlobalFilterTopbarEndAdornment';
import {openFilterDialog} from 'filters';
import {FilterTopbarProvider} from 'filters/features/FilterTopbar/context/FilterTopbarProvider';
import {createFiltersDropdownItem} from 'filters/features/FilterTopbar/items/FiltersDropdownItem/FiltersDropdownItem';
import {marketTopbarItems} from 'features/GlobalFilterProvider/filters/markets';
import {productsTopbarItem} from 'features/GlobalFilterProvider/filters/products';
import {industriesTopbarItems} from 'features/GlobalFilterProvider/filters/industries';
import {locationTopbarItem} from 'features/GlobalFilterProvider/filters/location';

const dropdownItem = createFiltersDropdownItem({
  id: FilterTopbarItemId.FiltersDropdown,
  onClick: () => openFilterDialog(FilterDialogSectionId.ActiveFilters),
});

export const GlobalFilterTopbarProvider = ({children}: PropsWithChildren) => {
  const periodItems = usePeriodTopbarItems();
  const teamsItems = useTeamsTopbarItems();
  const clientTagsItem = useClientTagsTopbarItem();
  const policyTagsItems = usePolicyTagsTopbarItems();
  return (
    <FilterTopbarProvider
      title='Decisions Filters'
      items={useMemo(
        () =>
          [
            dropdownItem,
            ...periodItems,
            ...marketTopbarItems,
            productsTopbarItem,
            ...departmentsTopbarItems,
            ...industriesTopbarItems,
            ...teamsItems,
            locationTopbarItem,
            clientTagsItem,
            ...policyTagsItems,
          ].filter(Boolean),
        [clientTagsItem, periodItems, policyTagsItems, teamsItems]
      )}
      useEndAdornment={useGlobalFilterTopbarEndAdornment}
    >
      {children}
    </FilterTopbarProvider>
  );
};
